export default {"id":"c13d010e","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}